import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.10",
  "description": "Turborepo 1.10은 로컬 개발 경험을 개선하는 새로운 기능을 도입합니다.",
  "date": "2023/06/01",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.10은 로컬 개발 경험을 개선하는 새로운 기능을 도입합니다:"
  }, {
    "heading": "",
    "content": "코드 제너레이터: turbo gen을 사용하여 새 작업 공간 생성 및 기존 작업 공간 복사를 포함한 소스 코드를 생성할 수 있습니다."
  }, {
    "heading": "",
    "content": "개선된 환경 변수 입력: 와일드카드 및 .env 지원으로 환경 변수에 더 쉽게 의존할 수 있습니다."
  }, {
    "heading": "",
    "content": "새로운 환경 모드: 이제 --env-mode=strict를 지정하여 작업 해시에 포함되는 환경 변수를 제어할 수 있습니다."
  }, {
    "heading": "",
    "content": "다음 명령으로 오늘 업데이트하세요"
  }, {
    "heading": "코드-제너레이터",
    "content": "Turborepo 제너레이터를 사용하면 예측 가능하고 구조화된 방식으로 저장소에 새 코드를 추가할 수 있습니다.\n이전에는 코드를 직접 복사하고 새 작업 공간에 종속성을 수동으로 추가해야 했습니다. 제너레이터를 사용하면\n새 작업 공간을 생성하고 저장소에 통합하는 프로세스가 자동화됩니다."
  }, {
    "heading": "코드-제너레이터",
    "content": "처음부터 빈 작업 공간을 생성하거나, 기존 작업 공간을 복사하거나, 더 많은 제어를 위해 커스텀 제너레이터를 생성할 수도 있습니다. 커스텀 제너레이터는 JavaScript 생태계에서 사용되는 일반적인 템플릿 정의 전략인 Plop 구성을 활용합니다."
  }, {
    "heading": "코드-제너레이터",
    "content": "커스텀 제너레이터는 작업 공간보다 더 세분화된 코드 세트를 스캐폴딩하는 데에도 사용할 수 있습니다. 다음과 같은 작업을 크게 가속화할 수 있습니다:"
  }, {
    "heading": "코드-제너레이터",
    "content": "UI 라이브러리에 새 컴포넌트 추가"
  }, {
    "heading": "코드-제너레이터",
    "content": "새 단위 테스트 생성"
  }, {
    "heading": "코드-제너레이터",
    "content": "새 MDX 블로그 포스트 생성"
  }, {
    "heading": "코드-제너레이터",
    "content": "다음을 실행하여 첫 번째 제너레이터를 시작하세요:"
  }, {
    "heading": "코드-제너레이터",
    "content": "자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "env-파일-지원",
    "content": ".env 파일은 환경 변수를 로드하는 데 일반적으로 사용됩니다. 이는 turbo로 실행할 때 문제를 일으킬 수 있습니다. 이러한 변수는 보이지 않을 수 있으며 작업의 해시에 쉽게 포함되지 않기 때문입니다. 이 문제는 로컬에서 작업할 때 의도하지 않은 캐시 히트를 유발할 수 있습니다."
  }, {
    "heading": "env-파일-지원",
    "content": "Turborepo는 이제 .env 파일에 대한 자동 지원으로 이를 훨씬 쉽게 만듭니다."
  }, {
    "heading": "env-파일-지원",
    "content": "Turborepo가 해시에 이러한 변수를 포함하도록 하려면 dotEnv 키를 사용하세요. 예를 들어, 다음은 Next.js 애플리케이션의 구성입니다:"
  }, {
    "heading": "env-파일-지원",
    "content": "이 기능은 시스템 환경 변수를 처리하지 않습니다. 개발 외부에서 .env\n파일을 사용하지 않는 경우 환경 변수가 해시에 포함되도록\nenv 또는\nglobalEnv에 여전히 열거되어 있는지\n확인하세요."
  }, {
    "heading": "env-파일-지원",
    "content": "자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "환경-변수-와일드카드",
    "content": "대규모 애플리케이션의 turbo.json에는 많은 환경 변수가 포함될 수 있습니다. 이로 인해 구성을 관리하고 유지하기 어려울 수 있습니다."
  }, {
    "heading": "환경-변수-와일드카드",
    "content": "와일드카드를 사용하면 이제 해시에 포함할 변수의 패턴을 지정할 수 있습니다."
  }, {
    "heading": "환경-변수-와일드카드",
    "content": "자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "환경-모드",
    "content": "Turborepo 환경 모드가 실험 모드에서 벗어나 일반 사용이 가능해졌습니다."
  }, {
    "heading": "환경-모드",
    "content": "기본적으로 그리고 turbo run이 --env-mode=loose로 호출될 때, 머신의 모든 환경 변수가 모든 Turborepo 작업에 제공됩니다.\n이는 최대 호환성을 보장하지만 작업이 turbo.json에 지정되지 않은 환경 변수에 암시적으로 액세스할 수 있는 일부 위험을 감수합니다."
  }, {
    "heading": "환경-모드",
    "content": "새로운 엄격 모드에서는 turbo가 --env-mode=strict로 호출될 때 중요한 시스템 환경 변수와 turbo.json 내부에 열거된 환경 변수만 작업에 제공됩니다."
  }, {
    "heading": "환경-모드",
    "content": "자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo v1.9 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "21.5k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 1.2M+회"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 85년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다:"
  }, {
    "heading": "커뮤니티",
    "content": "Jared, Greg, Nathan, Thomas, Mehul, Chris, Nicholas, Alexander"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
  }],
  "headings": [{
    "id": "코드-제너레이터",
    "content": "코드 제너레이터"
  }, {
    "id": "개선된-환경-변수-입력",
    "content": "개선된 환경 변수 입력"
  }, {
    "id": "env-파일-지원",
    "content": ".env 파일 지원"
  }, {
    "id": "환경-변수-와일드카드",
    "content": "환경 변수 와일드카드"
  }, {
    "id": "환경-모드",
    "content": "환경 모드"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Callout} from '#components/callout';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#코드-제너레이터",
  title: _jsx(_Fragment, {
    children: "코드 제너레이터"
  })
}, {
  depth: 2,
  url: "#개선된-환경-변수-입력",
  title: _jsx(_Fragment, {
    children: "개선된 환경 변수 입력"
  })
}, {
  depth: 3,
  url: "#env-파일-지원",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: ".env"
    }), " 파일 지원"]
  })
}, {
  depth: 3,
  url: "#환경-변수-와일드카드",
  title: _jsx(_Fragment, {
    children: "환경 변수 와일드카드"
  })
}, {
  depth: 3,
  url: "#환경-모드",
  title: _jsx(_Fragment, {
    children: "환경 모드"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.10"
    }), "\n", "\n", _jsx(Date, {
      children: "Thursday, June 1st, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['nathanhammond', 'tomknickman', 'anthonyshew', 'mehulkar']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.10은 로컬 개발 경험을 개선하는 새로운 기능을 도입합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#code-generators",
          children: _jsx(_components.strong, {
            children: "코드 제너레이터"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo gen"
        }), "을 사용하여 새 작업 공간 생성 및 기존 작업 공간 복사를 포함한 소스 코드를 생성할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-environment-variable-inputs",
          children: _jsx(_components.strong, {
            children: "개선된 환경 변수 입력"
          })
        }), ": 와일드카드 및 ", _jsx(_components.code, {
          children: ".env"
        }), " 지원으로 환경 변수에 더 쉽게 의존할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-modes",
          children: _jsx(_components.strong, {
            children: "새로운 환경 모드"
          })
        }), ": 이제 ", _jsx(_components.code, {
          children: "--env-mode=strict"
        }), "를 지정하여 작업 해시에 포함되는 환경 변수를 제어할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "다음 명령으로 오늘 업데이트하세요"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " migrate"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "코드-제너레이터",
      children: "코드 제너레이터"
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 rounded-xl border-2 border-[#f3f7fd] p-4 dark:border-[#1c2428]",
      light: {
        alt: 'turbo-gen',
        src: '/images/blog/turbo-1-10-0/turbo-gen-light.gif',
        props: {
          width: 600,
          height: 205
        }
      },
      dark: {
        alt: 'turbo-gen',
        src: '/images/blog/turbo-1-10-0/turbo-gen-dark.gif',
        props: {
          width: 600,
          height: 215
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 제너레이터를 사용하면 예측 가능하고 구조화된 방식으로 저장소에 새 코드를 추가할 수 있습니다.\n이전에는 코드를 직접 복사하고 새 작업 공간에 종속성을 수동으로 추가해야 했습니다. 제너레이터를 사용하면\n새 작업 공간을 생성하고 저장소에 통합하는 프로세스가 자동화됩니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides/generating-code#add-an-empty-package",
        children: "처음부터 빈 작업 공간을 생성"
      }), "하거나, ", _jsx(_components.a, {
        href: "/docs/guides/generating-code#copy-an-existing-package",
        children: "기존 작업 공간을 복사"
      }), "하거나, 더 많은 제어를 위해 커스텀 제너레이터를 생성할 수도 있습니다. 커스텀 제너레이터는 JavaScript 생태계에서 사용되는 일반적인 템플릿 정의 전략인 ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " 구성을 활용합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides/generating-code#custom-generators",
        children: "커스텀 제너레이터"
      }), "는 작업 공간보다 더 세분화된 코드 세트를 스캐폴딩하는 데에도 사용할 수 있습니다. 다음과 같은 작업을 크게 가속화할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/examples/basic/packages/ui/turbo/generators/config.ts",
          children: "UI 라이브러리에 새 컴포넌트 추가"
        })
      }), "\n", _jsx(_components.li, {
        children: "새 단위 테스트 생성"
      }), "\n", _jsx(_components.li, {
        children: "새 MDX 블로그 포스트 생성"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "다음을 실행하여 첫 번째 제너레이터를 시작하세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "문서"
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "개선된-환경-변수-입력",
      children: "개선된 환경 변수 입력"
    }), "\n", _jsxs(_components.h3, {
      id: "env-파일-지원",
      children: [_jsx(_components.code, {
        children: ".env"
      }), " 파일 지원"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://www.dotenv.org/docs/",
        children: [_jsx(_components.code, {
          children: ".env"
        }), " 파일"]
      }), "은 환경 변수를 로드하는 데 일반적으로 사용됩니다. 이는 ", _jsx(_components.code, {
        children: "turbo"
      }), "로 실행할 때 문제를 일으킬 수 있습니다. 이러한 변수는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#avoid-creating-or-mutating-environment-variables-at-runtime",
        children: "보이지 않을 수"
      }), " 있으며 작업의 해시에 쉽게 포함되지 않기 때문입니다. 이 문제는 로컬에서 작업할 때 의도하지 않은 캐시 히트를 유발할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 이제 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일에 대한 자동 지원으로 이를 훨씬 쉽게 만듭니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo가 해시에 이러한 변수를 포함하도록 하려면 ", _jsx(_components.code, {
        children: "dotEnv"
      }), " 키를 사용하세요. 예를 들어, 다음은 Next.js 애플리케이션의 구성입니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.production.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.production\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.development.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env.test.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env.test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: ["이 기능은 시스템 환경 변수를 처리하지 ", _jsx(_components.strong, {
          children: "않습니다"
        }), ". 개발 외부에서 ", _jsx(_components.code, {
          children: ".env"
        }), "\n파일을 사용하지 않는 경우 환경 변수가 해시에 포함되도록\n", _jsx(_components.a, {
          href: "/docs/reference/configuration#env",
          children: "env"
        }), " 또는\n", _jsx(_components.a, {
          href: "/docs/reference/configuration#globalenv",
          children: "globalEnv"
        }), "에 여전히 열거되어 있는지\n확인하세요."]
      })
    }), "\n", _jsx(_components.p, {
      children: "자세한 내용은 문서를 확인하세요."
    }), "\n", _jsx(_components.h3, {
      id: "환경-변수-와일드카드",
      children: "환경 변수 와일드카드"
    }), "\n", _jsxs(_components.p, {
      children: ["대규모 애플리케이션의 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에는 많은 환경 변수가 포함될 수 있습니다. 이로 인해 구성을 관리하고 유지하기 어려울 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "와일드카드를 사용하면 이제 해시에 포함할 변수의 패턴을 지정할 수 있습니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"ACME_*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#wildcards",
        children: "문서"
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "환경-모드",
      children: "환경 모드"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 환경 모드가 실험 모드에서 벗어나 일반 사용이 가능해졌습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 그리고 ", _jsx(_components.code, {
        children: "turbo run"
      }), "이 ", _jsx(_components.code, {
        children: "--env-mode=loose"
      }), "로 호출될 때, 머신의 모든 환경 변수가 모든 Turborepo 작업에 제공됩니다.\n이는 최대 호환성을 보장하지만 작업이 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 지정되지 않은 환경 변수에 암시적으로 액세스할 수 있는 일부 위험을 감수합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["새로운 엄격 모드에서는 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 ", _jsx(_components.code, {
        children: "--env-mode=strict"
      }), "로 호출될 때 ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: "중요한 시스템 환경 변수"
      }), "와 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 내부에 열거된 환경 변수만 작업에 제공됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#environment-modes",
        children: "문서"
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-9-0",
        children: "Turborepo v1.9"
      }), " 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "21.5k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 1.2M+회"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 85년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/jaredpalmer",
          children: "Jared"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/gsoltis",
          children: "Greg"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/nathanhammond",
          children: "Nathan"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/tknickman",
          children: "Thomas"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/mehulkar",
          children: "Mehul"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/chris-olszewski",
          children: "Chris"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/NicholasLYang",
          children: "Nicholas"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/arlyon",
          children: "Alexander"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
